/* this file added by Bearer Web Developer  */
import React from 'react';
import { useThemeMode } from '../../states/contexts/theme';
import styles from './swipeUp.module.scss';
const SwipeUP: React.FC = () => {

    const { theme } = useThemeMode();
    return (
        <div className={styles.swipe_up} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {
                theme === "dark" ?
                    <img src="/swipe-up-dark.svg" alt="" /> :
                    <img src="/swipe-up.svg" alt="" />
            }
            {/* <p>Swipe up to view the map</p> */}
            <p>Tap to view the map</p>
        </div>
    )
}
export default SwipeUP;